<div class="flx-modal" role="dialog" aria-modal="true" *ngIf="translate">
    <!-- header -->
    <div class="flx-modal__header">
        <h2>{{translate?.general.buttons.activate.singular}} {{translate?.customer.label.singular}} Portal</h2>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()" tooltipPosition="left">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__subheader">
        <h3>Enable portal access for all your {{translate?.customer.label.plural}}</h3>
    </div>
    <div class="flx-modal__body">
        <div class="portal-info">
            <span class="title">What happens when you activate</span>
            <span class="details">
                <ul class="list">
                    <li>&#8277;&nbsp;The {{translate?.customer.label.singular | lowercase}} Portal feature is enabled for your organisation</li>
                    <li>&#8277;&nbsp;You will be taken to the configuration page to set up branding, modules, and {{translate?.jobOrder.label.singular}} settings</li>
                </ul>
            </span>
        </div>
        <div class="portal-steps">
            <span class="title-plain">How {{translate?.customer.label.plural | lowercase}} get access</span>
            <ul class="details-plain">
                    <li><i class="fa-solid fa-circle-1"></i>&nbsp;Go to the <span class="font-semiBold">{{translate?.customer.label.singular}}</span> tab and open a {{translate?.customer.label.singular}} record </li>
                    <li><i class="fa-solid fa-circle-2"></i>&nbsp;Add a <span class="font-semiBold">{{translate?.contacts.label.singular}}</span> to the {{translate?.customer.label.singular}} and <span class="font-semiBold">enable portal access</span> for that {{translate?.contacts.label.singular}}</li>
                    <li><i class="fa-solid fa-circle-3"></i>&nbsp;From the {{translate?.contacts.label.singular}} record you can also <span class="font-semiBold">reset their password</span> or <span class="font-semiBold">revoke portal access</span> at any time</li>
                
            </ul>
        </div>
    </div>
     <!-- footer -->
    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.close.singular}}</button>
        <p-button styleClass="h-32" [label]="translate?.general.buttons.activate.singular" (onClick)="onActivate()"></p-button>
    </div>
</div>